import { z } from "zod";

/** Fastener brand codes (mirrors svc shared `FASTENER_BRAND_CODES`). */
export const FASTENER_BRANDS = ["PEM", "SHEREX", "PROFIL", "AUTORIV", "OTHER"] as const;
export type FastenerBrand = (typeof FASTENER_BRANDS)[number];

export const fastenerLineSchema = z.object({
  fastenerId: z.string().optional(),
  brand: z.enum(FASTENER_BRANDS),
  // Free text in the UI; mapped to null when empty before sending (backend
  // requires a non-empty string or null, max 50).
  type: z.string().max(50, "Max 50 characters").optional(),
  qtyPerPartA: z.coerce.number().min(0).optional(),
  qtyPerPartB: z.coerce.number().min(0).optional(),
});

export const editApplicationSchema = z.object({
  applicationName: z.string().min(1, "Application name is required"),
  panelPartNumber: z.string().min(1, "Panel part number is required"),
  oem: z.string().min(1, "OEM is required"),
  productionProgram: z.string().optional(),
  material: z
    .string()
    .max(100, "Material must be 100 characters or fewer")
    .optional(),
  annualProductionVolume: z.coerce.number().nonnegative().optional(),
  // Average batch size (parts/batch). Backend (svc-06 UpdateApplicationSchema)
  // requires a positive number when present; a blank field maps to undefined.
  averageBatchSize: z.preprocess(
    (v) => (v === "" || v === null ? undefined : v),
    z.coerce.number().positive("Must be greater than 0").optional(),
  ),
  // Owner email — display-only (not editable; svc-06 PATCH does not accept it).
  createdBy: z.string().optional(),
  fasteners: z.array(fastenerLineSchema),
});

export type EditApplicationFormData = z.infer<typeof editApplicationSchema>;
